import type { BillingInterval } from 'app/typings/billingIntervals';

export enum ADYEN_GENDER_INVOICING {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export type FinanceForm = {
  issuingActivated: boolean;
  finance: {
    bank?: string;
    iban?: string;
    vat?: string;
    invoicing: {
      hotelName?: string;
      gender?: ADYEN_GENDER_INVOICING;
      firstName?: string;
      lastName?: string;
      email?: string;
      city?: string;
      zipCode?: string;
      street?: string;
      country?: string;
      siret?: string;
    };
  };
  billingInterval: BillingInterval;
  eInvoicingId?: string;
};
